import PageMeta from "../../components/common/PageMeta";
import PageContainer from "../../components/common/PageContainer";
import PageHeader from "../../components/common/PageHeader";
import EthocaSettings from "./EthocaSettings";

export default function EthocaSettingsPage() {
  return (
    <div>
      <PageMeta
        title="Chargemont | Ethoca Settings"
        description="Chargemont | Ethoca Settings"
      />
      <PageContainer>
        <PageHeader title="Ethoca Settings" />
        <EthocaSettings />
      </PageContainer>
    </div>
  );
}
